import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "q-gutter-y-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Search Posts",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Search",
        color: "primary",
        task: _ctx.task,
        disabled: !_ctx.canCreate,
        onClick: _ctx.create
      }, null, 8, ["task", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keywords, (kw) => {
          return (_openBlock(), _createBlock(_component_q_input, {
            key: kw,
            "model-value": kw,
            dense: ""
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_btn, {
                icon: "fa fa-trash",
                title: "Remove keyword",
                flat: "",
                round: "",
                dense: "",
                onClick: ($event: any) => (_ctx.removeKeyword(kw))
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["model-value"]))
        }), 128)),
        _createVNode(_component_q_input, {
          modelValue: _ctx.keyword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
          placeholder: "Add keyword...",
          dense: "",
          autofocus: "",
          onKeyup: _withKeys(_ctx.addKeyword, ["enter"])
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_btn, {
              icon: "fa fa-plus",
              flat: "",
              round: "",
              onClick: _ctx.addKeyword
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "onKeyup"])
      ])
    ]),
    _: 1
  }, 512))
}